/* unplugin-vue-components disabled */import script from "./serviceIntr.vue?vue&type=script&setup=true&lang=js"
export * from "./serviceIntr.vue?vue&type=script&setup=true&lang=js"

import "./serviceIntr.vue?vue&type=style&index=0&id=271b12a8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.15_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-271b12a8"]])

export default __exports__